module.exports = {"data":{"site":{"siteMetadata":{"title":"File For EIN","domain":"www.fileforein.com","supportEmail":"support@FileForEIN.com","supportPhone":"888-375-8904"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/terms-of-services.json
// module id = 726
// module chunks = 239702244044551